'use client';

import { I18nextProvider } from 'react-i18next';
import { ReactNode, useEffect, useState } from 'react';
import { createInstance, i18n, Resource } from 'i18next';
import initTranslations from '@/i18n';

export default function TranslationsProvider({
  children,
  locale,
  namespaces = ['common'],
  resources,
}: {
  children: ReactNode;
  locale: string;
  namespaces?: string[];
  resources?: Resource;
}) {
  const [i18nInstance, setI18nInstance] = useState<i18n | null>(null);

  useEffect(() => {
    if (!i18nInstance) {
      const i18n = createInstance();
      initTranslations(locale, namespaces, i18n, resources).then(({ i18n }) => {
        setI18nInstance(i18n);
      });
    }
  }, [i18nInstance, locale, namespaces, resources]); // Only updates when these values change

  if (!i18nInstance) {
    return null;
  } // Prevent rendering until translations are ready

  return <I18nextProvider i18n={i18nInstance}>{children}</I18nextProvider>;
}
